/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class PermissionRequest extends MainRequest{


     static listAll() {
         return this.getSEC(ServicePath.PERMISSIONS_LIST_ALL);
     }

     static add(object) {
        return this.postSEC(ServicePath.PERMISSIONS_ADD, object);
     }

     static update(object) {
        return this.postSEC(ServicePath.PERMISSIONS_UPDATE, object);
     }

     static get(object) {
        return this.postSEC(ServicePath.PERMISSIONS_GET, object);
     }

     static delete(object) {
        return this.postSEC(ServicePath.PERMISSIONS_DELETE, object);
     }

 }